module.exports = __webpack_public_path__ + "static/media/tech-ai.fe1acb5b.png";